module.exports = __webpack_public_path__ + "img/icon_chatbot_onfan_w.cdf86a06.svg";